module.exports = __webpack_public_path__ + "static-portal/img/map-pta2.8e28da3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-pta2.jpg
// module id = n53W
// module chunks = 4